import React, { useState } from "react";
import WindowChrome from "./WindowChrome.jsx";

export const CASE_SCREENSHOT_SRC = "/images/cases/ozexteriors.png";

const CaseScreenshot = ({
  windowTitle = "live_site · ozexteriors.com.au",
  caption = "Their live website · ozexteriors.com.au",
}) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <div className="cursor-proof-evidence" data-testid="quiet-proof-screenshot-fallback">
        <div className="cursor-window cursor-proof-screenshot-window cursor-proof-window-accent">
          <WindowChrome title={windowTitle} variant="case" />
          <div className="cursor-proof-screenshot-empty">
            Website screenshot coming soon
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cursor-proof-evidence" data-testid="quiet-proof-screenshot">
      <div className="cursor-window cursor-proof-screenshot-window cursor-proof-window-accent">
        <WindowChrome title={windowTitle} variant="case" />
        <div className="cursor-proof-screenshot-body">
          <img
            src={CASE_SCREENSHOT_SRC}
            alt="Oz Exteriors live website — real roofing company using FractoLabs"
            className="cursor-proof-screenshot-image"
            loading="lazy"
            onError={() => setHasError(true)}
          />
        </div>
      </div>
      <p className="cursor-proof-screenshot-caption">{caption}</p>
    </div>
  );
};

export default CaseScreenshot;
